import React from 'react';
import PropTypes from 'prop-types';

/** FUNCTONS */
import createBreakpoints from './functions/create-breakpoints';
import createSpacings from './functions/create-spacings';
import createMixins from './functions/create-mixins';
/** MISC */
import { brand, system, common } from './colors';
import shadows from './shadows';

/** INITIAL STATE */
const initialState = {
  palette: {
    ...brand,
    ...system,
    ...common,
    background: common.white,
    paper: common.white,
    text: common.gray1,
    textSecondary: common.gray2,
  },

  shape: {
    small: 5, // Buttons, Inputs
    medium: 10, // Cards, Modals
    large: 20, // ??
  },

  zIndex: {
    navbar: 1100,
    offCanvas: 1200,
    modal: 1300,
  },

  breakpoints: createBreakpoints(),
  spacing: createSpacings(),
  mixins: createMixins(createSpacings()),

  shadows,
};

const ThemeContext = React.createContext(initialState);

/** REDUCER */
function reducer(state, action) {
  switch (action.type) {
    case 'SET_THEME':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}

/** PROP-TYPES */
const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

/**
 * Theme Provider
 *
 * @param {*} { children }
 * @returns
 */
export const ThemeProvider = ({ children }) => {
  const [state] = React.useReducer(reducer, initialState);
  return (
    <ThemeContext.Provider value={state}>{children}</ThemeContext.Provider>
  );
};

/** PROP-TYPES ASSIGNMENT */
ThemeProvider.propTypes = propTypes;

export default ThemeContext;
